import actionTypes from './actionTypes';

const initialState = {
  token: '',
  isAuthenticated: false,
  email: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${actionTypes.SIGN_IN}_SUCCESS`: {
      const data = action.payload.payload;
      return {
        ...state,
        email: data.email,
        token: data.token,
        isAuthenticated: true,
      };
    }
    case `${actionTypes.SIGN_UP}_SUCCESS`: {
      return {
        ...state,
      };
    }
    case `${actionTypes.CHECK_AUTH}_SUCCESS`: {
      return {
        ...state,
        isAuthenticated: action.payload.isAuthenticated,
        email: action.payload.email,
        token: action.payload.token,
      };
    }
    case actionTypes.LOGOUT: {
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('accessToken');
      localStorage.removeItem('__paypal_storage__');
      localStorage.removeItem('email');
      return {
        ...state,
        isAuthenticated: false,
        email: '',
        token: '',
      };
    }
    default: {
      return state;
    }
  }
};
